module.exports = __webpack_public_path__ + "fonts/ubuntu-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Ubuntu/ubuntu-regular-webfont.woff2
// module id = 3467
// module chunks = 0